<template>
  <div id="broker-card">
    <template v-if="broker">
      <v-card class="ma-1 elevation-0">
        <div class="broker-card-top pa-5 pb-0">
          <div class="broker-card-logo">
            <template v-if="getBrokerLogoSrc()">
              <img :src="getBrokerLogoSrc()" />
            </template>
            <template v-else>{{ broker.name }}</template>
          </div>
          <div class="broker-card-icons">
            <div v-if="broker.multiCurrency" class="mr-3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    class="broker-card-icons-multicurrency"
                    v-on="on"
                  >
                    mdi-cash-multiple
                  </v-icon>
                </template>
                <span>{{ $t('views.brokers.brokerAccounts.multiCurrency') }}</span>
              </v-tooltip>
            </div>
            <div
              v-if="broker.destinationRetention"
              class="broker-card-icons-destination-retention mr-3"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" size="20" v-on="on">
                    mdi-bank-check
                  </v-icon>
                </template>
                <span>{{ $t('views.brokers.brokerAccounts.destinationRetention') }}</span>
              </v-tooltip>
            </div>
            <div class="broker-card-icons-flag">
              <img :src="countrySrc" :width="22" />
            </div>
          </div>
        </div>
        <!-- <div class="broker-card-log-in px-5 pb-3 pt-3">
          <a
            v-if="getBrokerLink(broker)"
            target="_blank"
            :href="getBrokerLink(broker)"
            class="broker-card-log-in-link primary--text"
          >
            <v-icon :size="16" color="secondary" class="mb-1">mdi-login</v-icon>
            <span class="ml-2 secondary--text">{{ $t('views.brokers.brokerAccounts.login') }}</span>
          </a>
          <div v-else class="broker-card-log-in-no-link" />
        </div> -->
        <div class="broker-card-accounts px-5 pb-3 pt-3">
          {{ broker.alias }}
        </div>

        <div class="broker-card-totals px-5 py-2">
          <div
            class="items-flex"
            :class="{
              'darkTextGrey--text': !$vuetify.theme.dark,
              'dark_Textgrey--text': $vuetify.theme.dark,
            }"
          >
            <div class="mr-1">
              <span class="total-title">
                {{ $t('views.brokers.brokerAccounts.totalNotCashValue') }}:
              </span>
            </div>
            <currency :value="broker.totalNotCashValue" :currency="user.baseCurrency" />
          </div>
          <div
            class="items-flex"
            :class="{
              'darkTextGrey--text': !$vuetify.theme.dark,
              'dark_Textgrey--text': $vuetify.theme.dark,
            }"
          >
            <div class="mr-1">
              <span class="total-title">
                {{ $t('views.brokers.brokerAccounts.totalCashValue') }}:
              </span>
            </div>
            <currency :value="broker.totalCashValue" :currency="user.baseCurrency" />
          </div>
        </div>

        <div class="items-flex justify-between align-end px-5 pl-4 pt-2 pb-4">
          <div class="broker-card-add-input">
            <div>
              <router-link class="primary--text" to="/input">
                <v-icon color="primary" size="15" class="broker-card-add-input-icon">
                  mdi-plus
                </v-icon>
                <span>{{ $t('views.brokers.brokerAccounts.addInput') }}</span>
              </router-link>
            </div>

            <div class="mt-1">
              <router-link class="primary--text" :to="`/input?open=import&broker=${broker.code}`">
                <v-icon color="primary" size="15" class="broker-card-add-input-icon">
                  mdi-file-upload-outline
                </v-icon>
                <span>{{ $t('views.brokers.brokerAccounts.import') }}</span>
              </router-link>
            </div>
          </div>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" size="17" v-on="on" @click="$emit('edit', broker)">
                  mdi-pencil-outline
                </v-icon>
              </template>
              <span>{{ $t('common.edit') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </template>

    <template v-else>
      <v-card class="create-card elevation-0 ma-1" @click="$emit('create')">
        <div align="center">
          <template v-if="loading">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </template>
          <template v-else>
            <h1
              :class="{
                'secondary--text': !$vuetify.theme.dark,
                'white--text': $vuetify.theme.dark,
              }"
            >
              {{ $t('views.brokers.brokerAccounts.createBroker') }}
            </h1>
            <v-icon size="50" :color="$vuetify.theme.dark ? 'white' : 'secondary'">
              mdi-plus
            </v-icon>
          </template>
        </div>
      </v-card>
    </template>
  </div>
</template>

<script>
// import { find } from 'lodash'
import { mapState } from 'vuex'
import CountryFlag from '@/views/components/common/CountryFlag'
import Currency from '@/views/components/common/Currency'
// import predefinedBrokers from '@/lib/brokers/predefinedBrokers.json'

export default {
  components: { CountryFlag, Currency },
  props: {
    broker: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['user']),
    countrySrc() {
      try {
        return require(`@/assets/country/${this.broker.country.toLowerCase()}.png`)
      } catch (error) {
        return null
      }
    },
  },
  methods: {
    getBrokerLogoSrc() {
      try {
        if (this.$vuetify.theme.dark) {
          try {
            return require(`@/assets/broker/${this.broker.code}-dark.png`)
          } catch (error) {
            return require(`@/assets/broker/${this.broker.code}.png`)
          }
        } else {
          return require(`@/assets/broker/${this.broker.code}.png`)
        }
      } catch (error) {
        return null
      }
    },
    // getBrokerLink(broker) {
    //   if (broker.custom || !broker.code) return null
    //   const predefinedBroker = find(predefinedBrokers.brokers, { code: broker.code })
    //   if (!predefinedBroker) return null
    //   return predefinedBroker.link
    // },
  },
}
</script>

<style lang="scss">
#broker-card {
  .broker-card-top {
    display: flex;
    justify-content: space-between;

    .broker-card-logo {
      font-size: 16px;
      font-weight: 500;
      img {
        max-height: 22px;
        max-width: 135px;
      }
    }
    .broker-card-icons {
      display: flex;
      align-items: flex-start;
      .broker-card-icons-multicurrency {
        margin-bottom: 2px;
      }
    }
  }
  .broker-card-log-in {
    a.broker-card-log-in-link {
      font-size: 13px;
      text-decoration: none;
    }
    .broker-card-log-in-no-link {
      margin-top: 23px;
    }
  }
  .items-flex {
    display: flex;
    &.justify-between {
      justify-content: space-between;
    }
    &.align-end {
      align-items: flex-end;
    }
  }
  .broker-card-accounts {
    font-size: 14px;
    font-weight: 600;
  }
  .broker-card-totals {
    p {
      line-height: 0.4;
    }
  }
  .broker-card-add-input {
    text-align: left;
    a {
      text-decoration: none;
      font-size: 14px;
    }
    .broker-card-add-input-icon {
      margin-bottom: 2px;
      margin-right: 5px;
    }
  }
  .total-title {
    font-weight: 500;
  }

  .create-card {
    padding-top: 73px;
    padding-bottom: 73px;
    h1 {
      font-size: 17px;
      font-weight: 400;
    }
  }
}
</style>
